export default __webpack_public_path__ + "static/media/ImportDataTemplate.1f4b875e.xlsx";